import {Component, CUSTOM_ELEMENTS_SCHEMA, inject, OnDestroy, OnInit, signal} from '@angular/core';
import '@luigi-project/container';
import {ConfigService, FeatureTogglesService} from '@dcp/configurator';
import {LuigiContainer} from '@luigi-project/container';
import {GoogleAutocompleteService} from '@app/services/google-autocomplete.service';
import {LeadFormLuigiContext} from '@app/product/lead/lead.model';
import {LuigiLeadService} from '@app/product/lead/luigi-lead.service';
import {CrmAccountTrackingService} from '@app/services/crm-account-tracking.service';
import {Subscription} from 'rxjs';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';
import {UNLEASH_TOGGLES} from '@app/config/FeatureToggleConfig';

@UntilDestroy()
@Component({
  selector: 'dcp-lead-modal',
  standalone: true,
  templateUrl: './lead-modal.component.html',
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})

export class LeadModalComponent implements OnInit, OnDestroy {

  public siteKey: string;
  public url: string;
  public modalId: string = 'modal-lead-form';
  readonly gRecaptchaId: string = 'g-recaptcha-lead-form';

  public container: LuigiContainer;
  public context: LeadFormLuigiContext;
  private leadFormCaptchaSubscription: Subscription = Subscription.EMPTY;

  public leadFormWebComponentCaptchaFeatureToggle = signal<boolean>(false);

  private configService = inject(ConfigService);
  private leadService: LuigiLeadService = inject(LuigiLeadService);
  private autocompleteService: GoogleAutocompleteService = inject(GoogleAutocompleteService);
  private crmAccountTrackingService: CrmAccountTrackingService = inject(CrmAccountTrackingService);
  private togglesService: FeatureTogglesService = inject(FeatureTogglesService);

  constructor() {
    this.url = this.configService.getString('webComponents.leadFormModal');
    this.siteKey = this.configService.getString('RE_CAPTCHA_SITE_KEY');
  }

  ngOnInit(): void {
    this.container = document.querySelector('#dcp-lead-form-modal');

    this.crmAccountTrackingService.getAllParametersArray().forEach(param => {
      const paramValue = this.crmAccountTrackingService.getDataFromSessionStorage(param);

      if (paramValue) {
        this.context = this.leadService.updateContext(this.context, {['sessionStorageUserDataExist']: true});
      }

      this.context = this.leadService.updateContext(this.context, {[param]: paramValue});
    })

    this.container.addEventListener('initialized', () => {
      this.autocompleteService.isLoaded().then(() => {
        this.context = this.leadService.updateContext(this.context, {
          maps: window.google.maps,
          gRecaptchaSiteKey: this.siteKey,
          gRecaptchaId: this.gRecaptchaId
        });
        this.container.updateContext(this.context);

        this.modalId = this.context.modalId
          ? this.context.modalId
          : this.modalId;
      });
    });

    this.subscribeToFeatureToggles();
  }

  ngOnDestroy(): void {
    this.leadFormCaptchaSubscription.unsubscribe();
  }

  subscribeToFeatureToggles() {
    this.leadFormCaptchaSubscription = this.togglesService.isEnabled(UNLEASH_TOGGLES.leadFormCaptcha).pipe(
      untilDestroyed(this)
    ).subscribe((isEnabled) => {
      this.leadFormWebComponentCaptchaFeatureToggle.set(isEnabled);
    });
  }
}
